import { useSelector } from 'react-redux';
import { Spacer } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { ADVERTISING_URL, APP_LANDING_URL, BUSINESS_ACCOUNTS_GUIDE_URL, BUSINESS_ACCOUNTS_HOMEPAGE, HELP_CENTER_URL, HOW_IT_WORKS_URL, INFOBOARD_URL, JOBS_URL, JOBS_URL_NEW, MAIN_NAVIGATION_ABOUT_TAB_URL, PRESS_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import { getPressCenterUrl, getSustainabilityUrl } from 'libs/utils/press-center';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getLocale } from 'state/intl/selectors';
import LinkCell from '../LinkCell';
import LinksGroup from '../LinksGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const FirstColumn = _ref => {
  let {
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = useTranslate('header.main_navigation.about');
  const {
    track
  } = useTracking();
  const isSustainabilityPageEnabled = useSelector(getIsFeatureSwitchEnabled('sustainability_page_press_center_link'));
  const isPressMenuEnabled = useSelector(getIsFeatureSwitchEnabled('press_menu'));
  const isPressCenterLinkEnabled = useSelector(getIsFeatureSwitchEnabled('web_press_center_link'));
  const isJobsPageEnabled = useSelector(getIsFeatureSwitchEnabled('jobs_page'));
  const isNewJobsUrlEnabled = useSelector(getIsFeatureSwitchEnabled('new_jobs_career_portal'));
  const locale = useSelector(getLocale);

  const handleSustainabilityClick = () => {
    track(clickEvent({
      target: ClickableElement.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  };

  const renderDiscoverBlock = () => /*#__PURE__*/_jsxs(LinksGroup, {
    title: translate('discover.title'),
    children: [/*#__PURE__*/_jsx(LinkCell, {
      title: translate('discover.items.how_it_works'),
      url: HOW_IT_WORKS_URL
    }), /*#__PURE__*/_jsx(LinkCell, {
      title: translate('discover.items.app'),
      url: APP_LANDING_URL
    }), /*#__PURE__*/_jsx(LinkCell, {
      title: translate('discover.items.help'),
      url: HELP_CENTER_URL
    }), /*#__PURE__*/_jsx(LinkCell, {
      title: translate('discover.items.infoboard'),
      url: INFOBOARD_URL
    }), isBusinessAccountLinksVisible && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LinkCell, {
        title: translate('discover.items.pro'),
        url: BUSINESS_ACCOUNTS_HOMEPAGE
      }), /*#__PURE__*/_jsx(LinkCell, {
        title: translate('discover.items.pro_guide'),
        url: BUSINESS_ACCOUNTS_GUIDE_URL
      })]
    })]
  });

  const renderCompanyBlock = () => {
    const shortLocale = String(locale.substring(0, 2));
    const pressUrl = isPressCenterLinkEnabled ? getPressCenterUrl(shortLocale) : PRESS_URL;
    const jobsUrl = isNewJobsUrlEnabled ? JOBS_URL_NEW : JOBS_URL;
    return /*#__PURE__*/_jsxs(LinksGroup, {
      title: translate('company.title'),
      children: [/*#__PURE__*/_jsx(LinkCell, {
        title: translate('company.items.about'),
        url: MAIN_NAVIGATION_ABOUT_TAB_URL
      }), isJobsPageEnabled && /*#__PURE__*/_jsx(LinkCell, {
        testId: "jobs-link-header",
        title: translate('company.items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/_jsx(LinkCell, {
        title: translate('company.items.sustainability'),
        url: getSustainabilityUrl(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/_jsx(LinkCell, {
        title: translate('company.items.press'),
        url: pressUrl,
        testId: "press-link"
      }), /*#__PURE__*/_jsx(LinkCell, {
        title: translate('company.items.advertising'),
        url: ADVERTISING_URL
      })]
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [renderDiscoverBlock(), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.X2Large
    }), renderCompanyBlock()]
  });
};

export default FirstColumn;